import { render, staticRenderFns } from "./BidsAddBulkDropLoading.vue?vue&type=template&id=260a24a6"
import script from "./BidsAddBulkDropLoading.vue?vue&type=script&lang=js"
export * from "./BidsAddBulkDropLoading.vue?vue&type=script&lang=js"
import style0 from "./BidsAddBulkDropLoading.vue?vue&type=style&index=0&id=260a24a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports